import { Injectable } from "@angular/core";

@Injectable()
export class GenericTableService {

	public initilizeTable(length: number) {
		return Array(length).fill(5);
	}

}
